import { Pipe, PipeTransform } from '@angular/core';
import { ConstantsService } from '../constants/constants.service';
import { ConstantsUnitType } from '../constants/constants.interface';

/**
 * Convert unit notation.
 */
@Pipe({
  name: 'unit'
})
export class UnitPipe implements PipeTransform {

  /** Units constants. */
  units: ConstantsUnitType[];

  constructor(
    private constantsService: ConstantsService
  ) { }

  /**
   * Convert unit notation.
   *
   * Example:
   *  - Convert id to value;
   *  - Convert value to short.
   *
   * @note Because of how the legacy ui-router works, Constants may not always
   *  be available in the constructor. When migrated, move the unit setter.
   *
   * @todo How to match interface of output with return type?
   *
   * @param value The element's unit.
   * @param i Input type as key.
   * @param [o=value] Output type as key.
   * @param [def] Optional default value.
   * @returns Converted unit.
   */
  transform<Key extends keyof ConstantsUnitType>(
    value: ConstantsUnitType[Key], i: Key, o: keyof ConstantsUnitType = 'value', def?: any
  ): ConstantsUnitType[keyof ConstantsUnitType] {
    const input = i || '_id';

    this.units = this.units || this.constantsService.getUnitTypes();
    const unit = this.units.find(u => u[input] === value);
    return unit && unit[o] || def || '';
  }
}
